<template>
    <div class="l-ss-c-widget-voice-popup">
        <popup
            v-if="$configuration.features.voiceSearch"
            :opened="store.state.ui.isVoiceSearchActive"
            class="l-ss-c-search-popup-voice-search-popup"
            @close="closeVoicePopup">
            <voice-search-container :store="store"/>
        </popup>
    </div>
</template>
<script>
    import VoiceSearchContainer from '@/core/components/voice-search-container.vue';
    import RootComponentMixin from '../core/mixins/root-component';
    import Popup from '../core/components/popup';

    export default {
        components: {
            VoiceSearchContainer,
            Popup,
        },
        provide: RootComponentMixin.provide,
        props: {
            ...RootComponentMixin.props,
        },
        computed: {
            ...RootComponentMixin.computed,
        },
        watch: {
            'store.state.ui.isCompletionsVisible': {
                handler(value) {
                    if (value && !this.isFocused && this.value) {
                        this.$refs.input.focus();
                        this.isFocused = true;
                    }
                },
            },
            /*
             * 'store.state.ui.isVoiceSearchActive': {
             *     handler(value) {
             *         if (value) {
             *             this.$emit('voice-search', value);
             *             this.setPosition();
             *         } else {
             *             this.resetPosition();
             *         }
             *     },
             * },
             */
            'store.state.ui.isVoiceSearchActive'(value) {
                if (value) {
                    this.handleOpenVoicePopup();
                } else {
                    this.handleCloseVoicePopup();
                }
            },
        },
        methods: {
            ...RootComponentMixin.methods,

            toggleVoicePopup(value) {
                if (value) {
                    this.setPosition();
                } else {
                    this.resetPosition();
                }

                this.store.commit('ui/SET_PROPERTY', {
                    key: 'isVoiceSearchActive',
                    value: value === undefined ? !this.store.state.ui.isVoiceSearchActive : !!value,
                });

                this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchLoader', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCompletionsVisible', value: false });

                this.$emit('voice-search', value);
            },
            handleOpenVoicePopup() {
                this.setPosition();

                this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchLoader', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCompletionsVisible', value: false });

                this.$emit('voice-search', true);
            },
            handleCloseVoicePopup() {
                this.resetPosition();

                this.$emit('voice-search', false);
            },
            closeVoicePopup() {
                this.store.commit('ui/SET_PROPERTY', {
                    key: 'isVoiceSearchActive',
                    value: false,
                });
            },
            setPosition() {
                this.$wrapper = document.querySelector('.l-ss-c-host-wrapper-is-voice-popup');
                this.$wrapper.style.display = 'flex';
                this.bodyClient = document.body;
                this.bodyClient.style.overflow = 'hidden';
            },
            resetPosition() {
                this.$wrapper.style.display = 'none';
                this.bodyClient.style.overflow = 'auto';
            },
        },
    };
</script>
